export default {
      id: "brouillard-usage",
      viewBox: "0 0 91 91",
      url: "../dist/images/" + "sprite.svg#brouillard-usage",
      toString: function () {
        return this.url;
      }
    }